import React, { useState } from "react";
import * as api from "../api";

/**
 * Login screen — email + password against /api/login. On success
 * stores the session in localStorage (via api.login()) and invokes
 * onSuccess so App.jsx can swap to the main app shell.
 */
export default function LoginPage({ onSuccess }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      const user = await api.login(email.trim(), password);
      onSuccess && onSuccess(user);
    } catch (err) {
      setError(err.message || "Login failed");
    }
    setBusy(false);
  };

  return (
    <div style={{
      minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
      background: "linear-gradient(135deg, #0a0e1a 0%, #14182a 100%)",
      padding: 20, flexDirection: "column",
    }}>
      <div style={{
        width: "100%", maxWidth: 400,
        background: "var(--bg-secondary, #15192a)",
        border: "1px solid var(--border)", borderRadius: 14,
        padding: 32,
        boxShadow: "0 12px 32px rgba(0,0,0,0.5)",
      }}>
        <div style={{ textAlign: "center", marginBottom: 24 }}>
          <div style={{
            display: "inline-flex", alignItems: "center", justifyContent: "center",
            width: 56, height: 56, borderRadius: 14, padding: 8,
            background: "linear-gradient(135deg, #6b7df0, #8f6df5)",
            color: "#fff", marginBottom: 12,
          }}>
            {/* Hotel mark — same as the sidebar + favicon. */}
            <svg viewBox="0 0 64 64" width="100%" height="100%" aria-hidden="true">
              <g fill="currentColor">
                <rect x="14" y="18" width="14" height="32" rx="1.5" />
                <rect x="30" y="12" width="20" height="38" rx="1.5" />
                <rect x="18" y="22" width="3" height="3" /><rect x="22" y="22" width="3" height="3" />
                <rect x="18" y="28" width="3" height="3" /><rect x="22" y="28" width="3" height="3" />
                <rect x="18" y="34" width="3" height="3" /><rect x="22" y="34" width="3" height="3" />
                <rect x="18" y="40" width="3" height="3" /><rect x="22" y="40" width="3" height="3" />
                <rect x="34" y="17" width="3" height="3" /><rect x="39" y="17" width="3" height="3" /><rect x="44" y="17" width="3" height="3" />
                <rect x="34" y="23" width="3" height="3" /><rect x="39" y="23" width="3" height="3" /><rect x="44" y="23" width="3" height="3" />
                <rect x="34" y="29" width="3" height="3" /><rect x="39" y="29" width="3" height="3" /><rect x="44" y="29" width="3" height="3" />
                <rect x="34" y="35" width="3" height="3" /><rect x="39" y="35" width="3" height="3" /><rect x="44" y="35" width="3" height="3" />
                <rect x="38" y="42" width="4" height="8" />
              </g>
            </svg>
          </div>
          <h2 className="fw-700" style={{ fontSize: 22, color: "var(--text-primary)", margin: 0 }}>
            NeoHospFin
          </h2>
          <p className="text-xs text-muted mt-4">Sign in to continue</p>
        </div>

        <form onSubmit={submit}>
          <div className="form-group">
            <label className="form-label">Email</label>
            <input className="input" type="email" autoFocus required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@company.com" />
          </div>
          <div className="form-group">
            <label className="form-label">Password</label>
            <input className="input" type="password" required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••" />
          </div>

          {error && (
            <div style={{
              padding: "8px 12px", borderRadius: 8, marginBottom: 12,
              background: "rgba(239,68,68,0.10)", border: "1px solid rgba(239,68,68,0.35)",
              color: "var(--red-light)", fontSize: 13,
            }}>{error}</div>
          )}

          <button type="submit" className="btn btn-primary"
            disabled={busy || !email.trim() || !password}
            style={{ width: "100%", padding: "10px 14px", fontSize: 14 }}>
            {busy ? "Signing in…" : "Sign In"}
          </button>
        </form>

        {/* Company logo — full width to match the Sign In button. The
            white background extends past the image's own white so the
            wordmark sits inside a balanced white pill. */}
        <div style={{
          marginTop: 36,
          width: "100%",
          background: "#ffffff",
          borderRadius: 8,
          padding: "5px 24px",
          display: "flex", justifyContent: "center", alignItems: "center",
          boxSizing: "border-box",
        }}>
          <img src="/ambuja-logo.jpg" alt="Ambuja Neotia"
            style={{
              maxHeight: 30, maxWidth: "100%", objectFit: "contain",
              display: "block",
            }} />
        </div>
      </div>
    </div>
  );
}
